/**
 * traveller component
 *
 **/
import { Component, Input, OnInit } from '@angular/core';
import { Yii } from "libraries/interfaces/Yii";
import _forEach from 'lodash-es/forEach';
import _get from 'lodash-es/get';
import _set from 'lodash-es/set';

// libs
import { faEye, faEyeSlash, IconDefinition } from "@fortawesome/free-solid-svg-icons";

@Component({

    selector: 'travellerCard',
    templateUrl: 'travellerCard.html'
})
export class TravellerCardComponent implements OnInit {
    public Yii = Yii;
    @Input() public travellerList: any;
    @Input() public useApis: boolean = true;
    @Input() public showErrors: boolean = false;


    public apisFlag: any = {};
    public hasNoApis: string[] = [];
    public travellerDetails: boolean = false;
    public iconEye: IconDefinition = faEye;
    public iconEyeSlash: IconDefinition = faEyeSlash;


    public ngOnInit() {
        //verify apis
        this.setApisFlag();
    }

    /**
     * test APIs presence
     * update apisFlag object : add missing path in apisFlag.id
     * update hasNoApis : push traveller Id in hasNoApis array if no apis at all
     */
    public setApisFlag() {

        const apisListAdult = ["birthDate", "citizenship", "passport.number", "passport.validity", "passport.issuance"];
        const apisListChild = ["citizenship", "passport.number", "passport.validity", "passport.issuance"];
        // let passportFields = [  ];

        _forEach(this.travellerList, (traveller: any, key: string) => {
            let apisList = apisListAdult;
            let maxFields: number = 5;
            if (traveller.type && traveller.type === 'Infant' || traveller.type === 'Child') {
                apisList = apisListChild;
                maxFields = 4;
            }

            const tempArray: string[] = [];

            _forEach(apisList, (apisName: string) => {
                if (!_get(traveller, apisName, false)) {
                    tempArray.push(apisName);
                }
            });

            // if(traveller.passport){
            //     _forEach(passportFields, (field: string)=>{
            //         if( !_get(traveller, field, false) ){
            //             tempArray.push(field);
            //         }
            //     });
            //
            // }

            if (tempArray.length > 0) {
                _set(this.apisFlag, key, tempArray);
            }

            if (tempArray.length === maxFields) {
                this.hasNoApis.push(key);
            }

        });
    }
}
